import { createContext, useContext } from 'react';

interface PlaybackContextValue {
  useFullVideoDuration: boolean;
  onVideoEnded?: () => void;
}

const PlaybackContext = createContext<PlaybackContextValue>({
  useFullVideoDuration: false,
});

export const PlaybackProvider = PlaybackContext.Provider;
export const usePlaybackContext = () => useContext(PlaybackContext);
